import { API_BASE_URL } from '../../../../config';
import { signatureUploadFileName } from './signatureImageExport';

export async function uploadSignature(email: string, file: Blob): Promise<void> {
  const base = API_BASE_URL?.trim();
  if (!base) throw new Error('api_unavailable');

  const emailTrim = email.trim();
  const form = new FormData();
  form.append('email', emailTrim);
  form.append('file', file, signatureUploadFileName(emailTrim));

  const res = await fetch(`${base}/api/general-profile/signature`, {
    method: 'POST',
    body: form,
  });
  if (!res.ok) {
    throw new Error('upload_failed');
  }
}

export function isSignatureCaptured(progress: { signatureCaptured?: boolean } | null | undefined): boolean {
  return progress?.signatureCaptured === true;
}

/** Fetches signature PNG and returns an object URL (caller must revoke when done). */
export async function fetchSignaturePreviewUrl(email: string): Promise<string | null> {
  const base = API_BASE_URL?.trim();
  const emailTrim = email.trim();
  if (!base || !emailTrim) return null;

  const profileRes = await fetch(
    `${base}/api/general-profile?email=${encodeURIComponent(emailTrim)}`
  );
  if (!profileRes.ok) return null;
  const profile = await profileRes.json();
  if (!isSignatureCaptured(profile)) return null;

  const imgRes = await fetch(
    `${base}/api/general-profile/signature?email=${encodeURIComponent(emailTrim)}`
  );
  if (!imgRes.ok) return null;
  const blob = await imgRes.blob();
  if (!blob.size) return null;
  return URL.createObjectURL(blob);
}
